import React from 'react'
import {makeStyles, Typography} from "@material-ui/core";
import Title from "components/Title";
import HelpTooltip from "components/HelpTooltip";
import SwzGeneratorQuestion from "./SwzGeneratorQuestion";

const useStyle = makeStyles(theme => ({
    title: {
        background: theme.palette.background.greyBackground,
        padding: theme.spacing(1),
        borderRadius: theme.shape.borderRadius,
        display: "flex",
        justifyContent: "space-between",
        marginBottom: theme.spacing(2)
    },
    wrap: {
        marginLeft: theme.spacing(2)
    },
    helpText: {
        textIndent: -1 * theme.spacing(2),
        marginLeft: theme.spacing(2),
        marginBottom: theme.spacing()

    }
}));

function SwzGeneratorSection(
    {
        id,
        section,
        formikProps
    }) {
    const classes = useStyle();
    return (
        <div>
            <Title align="left" className={classes.title}>
                {section.text}
                {!!section.helpMessage && <HelpTooltip text={
                    new DOMParser().parseFromString(section.helpMessage, "text/html").documentElement.textContent}/>}
            </Title>
            <div className={classes.wrap}>
                {section.questions.map(x => (
                    <SwzGeneratorQuestion key={x.key} question={x} formikProps={formikProps}/>
                ))}
            </div>
            {
                !!section?.helpTexts.length && <div className={classes.wrap}>
                    {section.helpTexts.map(x => (
                        <Typography key={x.key} className={classes.helpText}>{x.message}</Typography>
                    ))}
                </div>
            }

        </div>
    )
}

export default SwzGeneratorSection;